import {useIssueCreateMetadata} from '@github-ui/issue-create/IssueCreateDataContext'
import {formatActorLogin} from '@github-ui/item-picker-assignee-tsq/utils/assignee-picker'
import isEqual from 'lodash-es/isEqual'

import type {DraftIssue} from '../content-preview-types'
import {useAssigneesQuery} from './use-assignees-query'
import {useDraftIssueFormSync} from './use-draft-issue-form-sync'
import {useOnChangeCallback} from './use-on-change-callback'

export function useDraftIssueAssignees(draftIssue: DraftIssue) {
  const {
    repository: formRepository,
    assignees: formAssignees,
    setAssignees: setFormAssignees,
  } = useIssueCreateMetadata()
  const onChange = useOnChangeCallback(draftIssue)

  return useDraftIssueFormSync(draftIssue, {
    draftValue: draftIssue.assignees,
    formValue: formAssignees,
    setFormValue: setFormAssignees,
    onChange: (newValue, skipVersionBump) =>
      onChange({assignees: newValue.map(a => formatActorLogin(a))}, skipVersionBump),
    resolverResult: useAssigneesQuery({
      owner: formRepository?.owner.login,
      repo: formRepository?.name,
      assignees: draftIssue.assignees ?? [],
    }),
    hasPermission: repo => repo?.viewerIssueCreationPermissions?.assignable,
    isEqual,
    defaultValue: [],
  })
}
